import { createSlice } from "@reduxjs/toolkit";
import Products from "../../pages/Products";

const foodSlice = createSlice({
    name: "Food",
    initialState: {
        cart: [],
        items: Products,
        totalQuantitys: 0,
        totalPrices: 0,
        val:0,
        cupancode:'hari25',
        afterdiscount:0
    },
    reducers: {
        AddItem: (state, action) => {
            let find = state.cart.findIndex((item) => item.id === action.payload.id);
            if (find >= 0) {
                state.cart[find].quantity += 1;
                state.totalPrices +=1
            } else {
                state.cart.push(action.payload)
            }
        },
        removItem: (state, action) =>{
            state.cart = state.cart.filter((ele) => ele.id !== action.payload)
        },
        getTotal:(state)=>{
            state.totalPrices = state.cart.reduce((a,b)=>a + b.price*b.quantity,0);
            state.totalQuantitys += 1
        },
        Inc:(state)=>{state.to += 1},
        Dec: (state) => { state.val -= 1 },
        afterdiscount: (state) => { state.afterdiscount = state.totalPrices - state.totalPrices/10 }
    }
})
 
export const { AddItem, removItem,getTotal ,Inc , Dec ,afterdiscount} = foodSlice.actions;

export default foodSlice.reducer;